import { CODE_LABEL_DIMENSIONS_MM, CodeLabelSize, generateCodeLabelsPdf } from '@shared/utils/codeLabelPdf';
import { Location } from '../models/Location';

export const LABEL_DIMENSIONS_MM = CODE_LABEL_DIMENSIONS_MM;

export type LabelSize = CodeLabelSize;

/**
 * Genera un PDF con una página por ubicación (misma lógica que la etiqueta individual).
 */
export async function generateLocationLabelsPdf(locations: Location[], labelSize: LabelSize): Promise<void> {
  if (locations.length === 0) return;

  const fileName =
    locations.length === 1
      ? `etiqueta_ubicacion_${locations[0].code}_${Date.now()}.pdf`
      : `etiquetas_ubicaciones_${Date.now()}.pdf`;

  await generateCodeLabelsPdf({
    labels: locations,
    labelSize,
    fileName,
  });
}
